import { each } from "../../../component";
import { html } from "lit-html";
import { TonerAction } from "../../../actions/toner/toner_action";
import { TonerJsEnv } from "../../../models/toner/toner_js_env";
import { PrinterType } from "../../../models/toner/printer_type";

const SEARCH_TYPE_PRINTER_TYPE = "2";
const SEARCH_TYPE_PRINTER_MODEL = "3";

export const MakerPulldownArea = (tonerJsEnv: TonerJsEnv) => html`
<div class="a-pulldown js-lazy-img -size48 -full">
  <label class="a-pulldown_label">
    <span class="a-pulldown_labeltxt">メーカー名</span>
    <span class="a-pulldown_select">
      <select id="toner-printer-maker"
        @change="${(event: Event) => {
          TonerAction.drillDown(SEARCH_TYPE_PRINTER_TYPE, getValueFromEvent(event), null);
        }}">
        ${(tonerJsEnv.printerMakers.length === 0) ? html``: html`<option value="" .selected=${tonerJsEnv.selectedPrinterMaker === ''}>メーカーを選択</option>`}
        ${each(CreatePrinterMaker(tonerJsEnv.printerMakers, tonerJsEnv.selectedPrinterMaker), MakerPulldown)}
      </select>
    </span>
  </label>
</div>
`;

const MakerPulldown = (printerMaker: PrinterMakerInterface) => html`
  <option value="${printerMaker.printerMaker}"
    .selected="${printerMaker.printerMaker === printerMaker.selectedPrinterMaker}">
    ${printerMaker.printerMaker}
  </option>
`;

export const PrinterTypePulldownArea = (tonerJsEnv: TonerJsEnv) => html`
<div class="a-pulldown js-lazy-img -size48 -full">
  <label class="a-pulldown_label">
    <span class="a-pulldown_labeltxt">プリンター種</span>
    <span class="a-pulldown_select">
      <select id="toner-printer-type"
        @change="${(event: Event) => {
          TonerAction.drillDown(SEARCH_TYPE_PRINTER_MODEL, tonerJsEnv.selectedPrinterMaker, Number(getValueFromEvent(event)));
        }}">
        ${(tonerJsEnv.printerTypes.length === 0) ? html``: html`<option value="" .selected=${tonerJsEnv.selectedPrinterType === null}>プリンター種を選択</option>`}
        ${each(CreatePrinterType(tonerJsEnv.printerTypes, tonerJsEnv.selectedPrinterType), PrinterTypePulldown)}
      </select>
    </span>
  </label>
</div>
`;

const PrinterTypePulldown = (printerType: PrinterTypeInterface) => html`
  <option value="${printerType.printerType}"
    .selected="${printerType.printerType === printerType.selectedPrinterType}">
    ${PrinterType.fromCode(printerType.printerType)?.name}
  </option>
`;

export const PrinterModelPulldownArea = (tonerJsEnv: TonerJsEnv) => html`
<div class="a-pulldown js-lazy-img -size48 -full">
  <label class="a-pulldown_label">
    <span class="a-pulldown_labeltxt">種類</span>
    <span class="a-pulldown_select">
      <select id="toner-printer-model" @change="${(event: Event) => TonerAction.updateSelectedPrinterModel(getValueFromEvent(event))}">
        ${(tonerJsEnv.printerModels.length === 0) ? html``: html`<option value="" .selected=${tonerJsEnv.selectedPrinterModel === ''}>種類を選択</option>`}
        ${each(CreatePrinterModel(tonerJsEnv.printerModels, tonerJsEnv.selectedPrinterModel), PrinterModelPulldown)}
      </select>
    </span>
  </label>
</div>
`;

const PrinterModelPulldown = (printerModel: PrinterModelInterface) => html`
  <option value="${printerModel.printerModel}"
    .selected=${printerModel.printerModel === printerModel.selectedPrinterModel}>
    ${printerModel.printerModel}
  </option>
`;

const getValueFromEvent = (event: Event) => {
  const { target } = event;

  if(!(target instanceof HTMLSelectElement)) {
    throw "cannot get value from event.";
  }

  return target.value;
}

const CreatePrinterMaker = (printerMakers: string[], selectedPrinterMaker: string) => {
  return printerMakers.map(printerMaker => {
    let printerMakerInterface: PrinterMakerInterface = {
      printerMaker: printerMaker,
      selectedPrinterMaker: selectedPrinterMaker
    }
    return printerMakerInterface;
  });
}

const CreatePrinterType = (printerTypes: number[], selectedPrinterType: number | null) => {
  return printerTypes.map(printerType => {
    let printerTypeInterface: PrinterTypeInterface = {
      printerType: printerType,
      selectedPrinterType: selectedPrinterType
    }
    return printerTypeInterface;
  });
}

const CreatePrinterModel = (printerModels: string[], selectedPrinterModel: string) => {
  return printerModels.map(printerModel => {
    let printerModelInterface: PrinterModelInterface = {
      printerModel: printerModel,
      selectedPrinterModel: selectedPrinterModel
    }
    return printerModelInterface;
  });
}

interface PrinterMakerInterface {
  printerMaker: string;
  selectedPrinterMaker: string;
}

interface PrinterTypeInterface {
  printerType: number;
  selectedPrinterType: number | null;
}

interface PrinterModelInterface {
  printerModel: string;
  selectedPrinterModel: string;
}
